import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, RotateCcw, ImageOff } from "lucide-react";
import { uploadImage, formatApiError } from "../../lib/api";
import { inputCls } from "./Field";

export const ImageField = ({ label, value, onChange, fallback, testid, dark = true, contain = false }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const shown = value || fallback;

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      onChange(await uploadImage(file));
      toast.success("Photo uploaded — remember to save.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid={testid}>
      <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">{label}</span>
      <div className="flex gap-3">
        <div className={`grid h-20 w-28 shrink-0 place-items-center overflow-hidden rounded-lg border border-white/10 ${dark ? "bg-[#0B0B0E]" : "bg-white"}`}>
          {shown ? <img src={shown} alt="" loading="lazy" decoding="async" className={`h-full w-full ${contain ? "object-contain p-2" : "object-cover"}`} /> : <ImageOff size={18} className="text-zinc-600" />}
        </div>
        <div className="min-w-0 flex-1 space-y-2">
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testid}-upload-btn`}
              className="inline-flex items-center gap-1.5 rounded-full bg-[#CCFF00] px-4 py-2 text-sm font-bold text-black disabled:opacity-50">
              <Upload size={14} /> {busy ? "Uploading…" : "Upload photo"}
            </button>
            {value && fallback !== undefined && (
              <button type="button" onClick={() => onChange("")} data-testid={`${testid}-reset-btn`}
                className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-2 text-sm text-zinc-300 hover:border-white/30">
                <RotateCcw size={14} /> Use default
              </button>
            )}
          </div>
          <input className={inputCls} value={value || ""} placeholder="…or paste an image link" onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-url`} />
          <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif,image/svg+xml" hidden onChange={pick} data-testid={`${testid}-file`} />
        </div>
      </div>
    </div>
  );
};
